(function () {
  'use strict';

  var headingSelector = [
    '#MainContent .tp-home-section-head > h2',
    '#MainContent .bp-bestseller-header > h2',
    '#MainContent .bp-header-title > h2',
    '#MainContent .tp-about-v2__section h2',
    '#MainContent .tp-contact__intro h2',
    '#MainContent .tp-contact__form-card > h2',
    '#MainContent .tp-contact__prep > h2',
    '#MainContent .tp-gift-finder__header h2',
    '#MainContent .tp-photo-confidence__header h2',
    '#MainContent .tp-seo-hub__header h2',
    '#MainContent .tp-order-confidence__header h2',
    '#MainContent .tp-trust-strip__content h2',
    '#MainContent .title-wrapper-with-link > h2',
    '#MainContent .title-wrapper > h2',
    '#MainContent .collection-hero__title',
    '#MainContent .collection__title h2',
    '#MainContent .multicolumn .title',
    '#MainContent .rich-text__heading',
    '#MainContent .image-with-text__heading',
    '#MainContent .blog__title',
    '#MainContent .product-video-carousel__title',
    '#MainContent .recently-title',
    '#MainContent .video-block-title',
    '#MainContent h2:not(.visually-hidden):not(.accordion__title):not(.card__heading):not(.h1)'
  ].join(',');

  function splitTitle(text) {
    var clean = text.replace(/\s+/g, ' ').trim();
    var words = clean.split(' ');

    if (words.length > 1) {
      var pivot = Math.ceil(words.length / 2);
      return [words.slice(0, pivot).join(' '), words.slice(pivot).join(' ')];
    }

    var characterPivot = Math.max(1, Math.ceil(clean.length / 2));
    return [clean.slice(0, characterPivot), clean.slice(characterPivot)];
  }

  function subtitleFor(title) {
    var value = title.toLowerCase();
    if (/best|seller|favorite|popular/.test(value)) return 'Customer favorites, made personal.';
    if (/gift/.test(value)) return 'Thoughtful keepsakes for every pet lover.';
    if (/photo/.test(value)) return 'Start with a clear photo, we handle the rest.';
    if (/how|made|process|craft/.test(value)) return 'A simple path from photo to keepsake.';
    if (/review|love|community/.test(value)) return 'Real moments shared by pet families.';
    if (/story|about|bond/.test(value)) return 'Inspired by the pets who make home feel whole.';
    if (/promise|trust|confidence/.test(value)) return 'Clear expectations from upload to delivery.';
    if (/faq|question|help/.test(value)) return 'Helpful answers before you order.';
    if (/blog|guide|learn/.test(value)) return 'Ideas and tips for creating the perfect keepsake.';
    if (/collection|shop|keepsake/.test(value)) return 'Personalized pieces for everyday joy.';
    return 'Made with care, designed to be remembered.';
  }

  function headingAlignment(heading) {
    var align = window.getComputedStyle(heading).textAlign;
    if (align === 'center') return 'tp-heading--center';
    if (align === 'right' || align === 'end') return 'tp-heading--right';
    return 'tp-heading--left';
  }

  function headingText(heading) {
    var copy = heading.cloneNode(true);
    copy.querySelectorAll('.visually-hidden').forEach(function (node) { node.remove(); });
    return copy.textContent.replace(/\s+/g, ' ').trim();
  }

  function enhanceHeading(heading) {
    if (!heading || heading.classList.contains('visually-hidden')) return;
    if (heading.dataset.tpDesignEnhanced === 'true') return;
    if (heading.closest('.product__info-container, .accordion, .card, .facets, facet-filters-form, .product-count, .mobile-facets, .collection-hero__description, .tp-market-card, .tp-home-product, .bp-product-card, .bp-bestseller-card, .multicolumn-card, .article-card, .tp-gift-card, .tp-seo-hub-card, .tp-contact-card, .video-card-item')) return;

    var title = heading.dataset.tpOriginalTitle || headingText(heading);
    if (!title) return;

    heading.dataset.tpOriginalTitle = title;
    heading.dataset.tpDesignEnhanced = 'true';
    heading.classList.add('tp-design-heading', headingAlignment(heading));
    heading.setAttribute('aria-label', title);

    var parts = splitTitle(title);
    heading.textContent = '';

    var base = document.createElement('span');
    base.className = 'tp-design-heading__base';
    base.textContent = parts[0];
    heading.appendChild(base);

    if (parts[1]) {
      heading.appendChild(document.createTextNode(' '));
      var accent = document.createElement('span');
      accent.className = 'tp-design-heading__accent';
      accent.textContent = parts[1];
      heading.appendChild(accent);
    }

    if (heading.classList.contains('collection-hero__title')) return;

    var parent = heading.parentElement;
    if (!parent) return;

    var subtitle = Array.prototype.find.call(parent.children, function (child) {
      return child !== heading && child.tagName === 'P';
    });

    if (!subtitle && heading.nextElementSibling && heading.nextElementSibling.tagName === 'P') {
      subtitle = heading.nextElementSibling;
    }

    if (!subtitle) {
      subtitle = document.createElement('p');
      subtitle.textContent = subtitleFor(title);
      heading.insertAdjacentElement('afterend', subtitle);
    }

    subtitle.classList.add('tp-design-subtitle');
  }

  function normalizeCollectionHero(root) {
    root.querySelectorAll('.collection-hero').forEach(function (hero) {
      hero.classList.add('tp-collection-hero--title-only');
      var title = hero.querySelector('.collection-hero__title');
      if (title) enhanceHeading(title);
    });
  }

  function enhanceProductCards(root) {
    root.querySelectorAll('.tp-home-product__button, .bp-btn-link, .bp-bestseller-btn-link, .tp-market-card__button').forEach(function (button) {
      button.textContent = 'View Product';
    });

    root.querySelectorAll('.card-wrapper.product-card-wrapper, .product-card-wrapper').forEach(function (card) {
      if (card.querySelector('.tp-view-product')) return;

      var productLink = card.querySelector('.card__heading a[href*="/products/"], a.full-unstyled-link[href*="/products/"]');
      if (!productLink) return;

      var target = card.querySelector('.card__information') || card.querySelector('.card__content') || card;
      var button = document.createElement('a');
      button.className = 'tp-view-product';
      button.href = productLink.href;
      button.textContent = 'View Product';
      button.setAttribute('aria-label', 'View product: ' + productLink.textContent.trim());
      target.appendChild(button);
    });

    root.querySelectorAll('.product-card-wrapper .badge, .card-product .badge').forEach(function (badge) {
      if (/^sale$/i.test(badge.textContent.trim())) badge.remove();
    });
  }

  function numberedTagOrder(item) {
    var card = item.matches('[data-product-tags]') ? item : item.querySelector('[data-product-tags]');
    if (!card) return null;

    var tags = (card.dataset.productTags || '').split(',');
    var order = null;
    tags.forEach(function (tag) {
      var value = tag.trim();
      if (!/^\d{4}$/.test(value)) return;
      var number = parseInt(value, 10);
      if (number < 1) return;
      if (order === null || number < order) order = number;
    });
    return order;
  }

  function sortProductContainer(container) {
    if (!container || container.dataset.tpSortReady === 'true') return;

    var settingsRoot = container.closest('[data-tp-product-sort]');
    if (!settingsRoot || settingsRoot.dataset.tpProductSort !== 'tag_number') return;

    var items = Array.prototype.slice.call(container.children).filter(function (item) {
      return item.matches('[data-product-tags]') || item.querySelector('[data-product-tags]');
    });
    if (items.length < 2) return;

    var sortable = items.map(function (item, index) {
      return { item: item, index: index, order: numberedTagOrder(item) };
    });
    if (!sortable.some(function (entry) { return entry.order !== null; })) {
      container.dataset.tpSortReady = 'true';
      return;
    }

    sortable.sort(function (a, b) {
      if (a.order === null && b.order === null) return a.index - b.index;
      if (a.order === null) return 1;
      if (b.order === null) return -1;
      return a.order - b.order || a.index - b.index;
    });
    sortable.forEach(function (entry) { container.appendChild(entry.item); });
    container.dataset.tpSortReady = 'true';
  }

  function collectionPageCount(root) {
    var pages = [1];
    root.querySelectorAll('.pagination a[href*="page="]').forEach(function (link) {
      try {
        pages.push(parseInt(new URL(link.href, location.origin).searchParams.get('page') || '1', 10));
      } catch (error) {
        pages.push(1);
      }
    });
    return Math.max.apply(Math, pages.filter(Number.isFinite));
  }

  async function sortCollectionAcrossPages(root) {
    if (!root || root.dataset.tpCollectionSortReady === 'true' || root.dataset.tpCollectionSortLoading === 'true') return;

    var grid = root.querySelector('#product-grid');
    if (!grid) return;

    var totalPages = collectionPageCount(root);
    if (totalPages <= 1) {
      sortProductContainer(grid);
      root.dataset.tpCollectionSortReady = 'true';
      root.dataset.tpTotalSortedProducts = String(grid.children.length);
      return;
    }

    root.dataset.tpCollectionSortLoading = 'true';
    var currentPage = parseInt(new URL(location.href).searchParams.get('page') || '1', 10);
    var pageSize = parseInt(root.dataset.tpProductsPerPage || '0', 10) || grid.children.length;
    var allItems = [];

    try {
      for (var pageNumber = 1; pageNumber <= totalPages; pageNumber += 1) {
        if (pageNumber === currentPage) {
          allItems = allItems.concat(Array.prototype.slice.call(grid.children));
          continue;
        }

        var pageUrl = new URL(location.href);
        pageUrl.searchParams.set('page', String(pageNumber));
        pageUrl.searchParams.set('_tp_sort_fetch', '1');
        var response = await fetch(pageUrl.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection sort page request failed');
        var parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        var fetchedGrid = parsed.querySelector('#product-grid');
        if (!fetchedGrid) throw new Error('Collection sort grid was not found');
        allItems = allItems.concat(Array.prototype.slice.call(fetchedGrid.children));
      }

      var sortable = allItems.map(function (item, index) {
        return { item: item, index: index, order: numberedTagOrder(item) };
      });
      sortable.sort(function (a, b) {
        if (a.order === null && b.order === null) return a.index - b.index;
        if (a.order === null) return 1;
        if (b.order === null) return -1;
        return a.order - b.order || a.index - b.index;
      });

      var start = Math.max(0, (currentPage - 1) * pageSize);
      var pageItems = sortable.slice(start, start + pageSize).map(function (entry) { return entry.item; });
      grid.replaceChildren.apply(grid, pageItems);
      root.dataset.tpCollectionSortReady = 'true';
      root.dataset.tpTotalSortedProducts = String(sortable.length);
      enhanceProductCards(root);
      if (window.jdgm && typeof window.jdgm.renderWidgets === 'function') {
        window.jdgm.renderWidgets(root);
      }
    } catch (error) {
      root.dataset.tpCollectionSortError = 'true';
      sortProductContainer(grid);
    } finally {
      delete root.dataset.tpCollectionSortLoading;
    }
  }

  function sortProductSections(root) {
    root.querySelectorAll(
      '[data-tp-product-sort="tag_number"] .bp-bestseller-scroll,' +
      '[data-tp-product-sort="tag_number"] .bp-scroll-container,' +
      '[data-tp-product-sort="tag_number"] .tp-under-30__grid,' +
      '[data-tp-product-sort="tag_number"] .tp-home-product-grid'
    ).forEach(sortProductContainer);

    root.querySelectorAll('[data-tp-product-sort="tag_number"]').forEach(function (settingsRoot) {
      if (settingsRoot.querySelector('#product-grid')) sortCollectionAcrossPages(settingsRoot);
    });
  }

  function makeArrowAccessible(arrow, label) {
    if (!arrow) return;
    arrow.setAttribute('role', 'button');
    arrow.setAttribute('tabindex', '0');
    arrow.setAttribute('aria-label', label);
    arrow.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        arrow.click();
      }
    });
  }

  function addSliderControls(scroller, previous, next) {
    if (!scroller || !previous || !next || scroller.dataset.tpControlsReady === 'true') return;

    scroller.dataset.tpControlsReady = 'true';
    var controls = document.createElement('div');
    controls.className = 'tp-card-slider-controls';

    var dots = document.createElement('span');
    dots.className = 'tp-slider-dots';
    dots.setAttribute('aria-hidden', 'true');
    dots.innerHTML = '<span class="tp-slider-dot is-active"></span><span class="tp-slider-dot"></span>';

    makeArrowAccessible(previous, 'Previous products');
    makeArrowAccessible(next, 'Next products');
    controls.appendChild(previous);
    controls.appendChild(dots);
    controls.appendChild(next);
    scroller.insertAdjacentElement('afterend', controls);

    var update = function () {
      var available = Math.max(1, scroller.scrollWidth - scroller.clientWidth);
      var progress = Math.min(1, Math.max(0, scroller.scrollLeft / available));
      var dotList = dots.querySelectorAll('.tp-slider-dot');
      dotList[0].classList.toggle('is-active', progress < .5);
      dotList[1].classList.toggle('is-active', progress >= .5);
    };

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function enhanceCustomSliders(root) {
    root.querySelectorAll('.bp-tab-content').forEach(function (panel) {
      addSliderControls(
        panel.querySelector('.bp-scroll-container'),
        panel.querySelector('.bp-arrow.left'),
        panel.querySelector('.bp-arrow.right')
      );
    });

    root.querySelectorAll('.bp-bestseller-scroll').forEach(function (scroller) {
      var parent = scroller.parentElement;
      addSliderControls(
        scroller,
        parent && parent.querySelector('.bp-bestseller-arrow.left'),
        parent && parent.querySelector('.bp-bestseller-arrow.right')
      );
    });
  }

  function initialize(root) {
    var scope = root && root.querySelectorAll ? root : document;
    normalizeCollectionHero(scope);
    scope.querySelectorAll(headingSelector).forEach(enhanceHeading);
    enhanceProductCards(scope);
    sortProductSections(scope);
    enhanceCustomSliders(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  var sortRefreshTimer;
  new MutationObserver(function (mutations) {
    if (!mutations.some(function (mutation) { return mutation.addedNodes.length > 0; })) return;
    window.clearTimeout(sortRefreshTimer);
    sortRefreshTimer = window.setTimeout(function () { sortProductSections(document); }, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
